function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import { SubMenu } from 'moduleBase/components/menu/SubMenu';
import { MenuItemCounter } from 'moduleBase/components/menu/MenuItemCounter';
import { When } from 'react-if';
import { NavLink } from 'components/router/NavLink';
import { useNetworkService } from 'hooks/use-network-service';
import { MenuItemContent } from './MenuItemContent';

var MenuItem = function MenuItem(_ref) {
  var label = _ref.label,
      id = _ref.id,
      route = _ref.route,
      async = _ref.async,
      url = _ref.url,
      target = _ref.target,
      badge = _ref.badge,
      image = _ref.image,
      icon = _ref.icon,
      counter = _ref.counter,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? null : _ref$onClick,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? null : _ref$className,
      _ref$subMenu = _ref.subMenu,
      subMenu = _ref$subMenu === void 0 ? null : _ref$subMenu,
      _ref$subMenuDynamic = _ref.subMenuDynamic,
      subMenuDynamic = _ref$subMenuDynamic === void 0 ? null : _ref$subMenuDynamic,
      _ref$imageWidth = _ref.imageWidth,
      imageWidth = _ref$imageWidth === void 0 ? null : _ref$imageWidth,
      _ref$imageClassName = _ref.imageClassName,
      imageClassName = _ref$imageClassName === void 0 ? 'dropdown-flat-list__icon' : _ref$imageClassName,
      _ref$buildNavLinkProp = _ref.buildNavLinkProp,
      buildNavLinkProp = _ref$buildNavLinkProp === void 0 ? null : _ref$buildNavLinkProp,
      data = _ref.data,
      _ref$activeId = _ref.activeId,
      activeId = _ref$activeId === void 0 ? null : _ref$activeId,
      visible = _ref.visible,
      notify = _ref.notify;

  if (!visible) {
    return null;
  }

  var networkService = useNetworkService();

  var isActive = function isActive() {
    return activeId && activeId.includes(id);
  };

  if (!url) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
      className: className
    }, label), /*#__PURE__*/React.createElement(SubMenu, {
      subMenu: subMenu
    }));
  }

  var handlerClick = function handlerClick(e) {
    if (async) {
      e.preventDefault();
      networkService.get(url).then(function () {
        window.location.href = process.env.BASE_URL;
      });
      return;
    }

    if (onClick) {
      onClick();
    }
  };

  if (!async && route) {
    var additionalProps = buildNavLinkProp ? buildNavLinkProp(url, data) : null;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(NavLink, _extends({
      to: url,
      id: id,
      className: className,
      onClick: handlerClick,
      isActive: isActive
    }, additionalProps), /*#__PURE__*/React.createElement(MenuItemContent, {
      label: label,
      badge: badge,
      icon: icon,
      image: image,
      imageWidth: imageWidth,
      imageClassName: imageClassName,
      notify: notify
    })), /*#__PURE__*/React.createElement(MenuItemCounter, {
      counter: counter
    }), /*#__PURE__*/React.createElement(SubMenu, {
      subMenu: subMenu,
      activeId: activeId
    }), /*#__PURE__*/React.createElement(When, {
      condition: isActive()
    }, /*#__PURE__*/React.createElement(SubMenu, {
      subMenu: subMenuDynamic,
      activeId: activeId
    })));
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("a", {
    href: url,
    id: id,
    className: className,
    target: target,
    onClick: handlerClick
  }, /*#__PURE__*/React.createElement(MenuItemContent, {
    label: label,
    badge: badge,
    icon: icon,
    image: image,
    imageWidth: imageWidth,
    imageClassName: imageClassName,
    notify: notify
  })), /*#__PURE__*/React.createElement(MenuItemCounter, {
    counter: counter
  }), /*#__PURE__*/React.createElement(SubMenu, {
    subMenu: subMenu
  }));
};

export { MenuItem };